import { type FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

export const AverageSpendingField: FC = () => {
  const {
    setValue,
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  const value = useWatch({ control, name: "averageSpending" });
  const errorMessage = errors.averageSpending?.message;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("averageSpending", e.target.value);
  };
  return <Presentation value={value} onChange={handleChange} errorMessage={errorMessage} />;
};
